import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { ServiceStatusDocument, serviceStatusPullQueryBuilder } from './queryBuilder';

export function serviceStatusFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<ServiceStatusDocument> {
  const syncConfig = configBuilder<ServiceStatusDocument>(RxdbCollectionNameV2.SERVICE_STATUS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, serviceStatusPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SERVICE_STATUS, replicationState, [sites]);
}
